// Quy đổi cân theo thể tích đang áp (Super Admin bật / tắt + đổi công thức) — form tạo đơn / sản phẩm tính
// "Tính cước theo" đúng như máy chủ. Chưa tải xong / lỗi → quy tắc BEST mặc định; báo giá máy chủ vẫn là số chốt.
import { useQuery } from "@tanstack/react-query"
import { DEFAULT_VOLUMETRIC_RULE, type VolumetricRule } from "@shoptrack/common/price-grid"
import { get } from "@/lib/api"

export function useVolumetricRule(): VolumetricRule {
  const { data } = useQuery({
    queryKey: ["shipping", "volumetric-rule"],
    queryFn: () => get<{ rule: VolumetricRule }>("/shipping/volumetric-rule"),
    staleTime: 5 * 60_000,
  })
  return data?.rule ?? DEFAULT_VOLUMETRIC_RULE
}
